import { createAction, props } from '@ngrx/store';
import { ArkikAlertService } from '@shared/components/arkik-alert/arkik-alert.service';

export type CatalogKind = 'catalogs' | 'vehicles' | 'groups';
export interface CatalogRequest {
  requestId: string;
  contextKey: string;
}

// Bound the entire operation, including IDB persistence.
export const CATALOG_OPERATION_TIMEOUT_MS = 20000;

export const retryCatalogOperation = createAction(
  '[Catalog Coordination] Retry',
  props<{ catalog: CatalogKind; contextKey: string }>(),
);

export function reportCatalogError(
  alert: ArkikAlertService,
  catalog: CatalogKind,
  request: CatalogRequest,
  error: unknown,
  fallback: string,
  retryLabel: string,
): string {
  const response = error as { error?: { message?: string }; message?: string };
  const message = response?.error?.message || response?.message || fallback;
  console.error(`Catalog ${catalog} load/IDB restoration failed`, error);
  alert.show({
    message,
    variant: 'error',
    keepOpen: true,
    ctaMessage: retryLabel,
    ctaAction: retryCatalogOperation({ catalog, contextKey: request.contextKey }),
  });
  return message;
}
